import inViewport from "../../js/lib/in-viewport";
import { isOver, set } from "../../js/lib/util";

export default (el: HTMLElement) => {
  const parallaxImage = el.dataset.parallaxImage === "true";
  const parallaxContent = el.dataset.parallaxContent === "true";
  const checkInViewport = el.dataset.inviewport === "true";
  const featuredImage = el.querySelector(".js-hero-img") as HTMLElement;
  const breakpoint = 1023;
  const featuredImageShiftScale = 0.3;

  const shift = (target: HTMLElement, scale: number) => {
    if (!target) {
      return;
    }

    if (!isOver(breakpoint)) {
      return;
    }

    const y = el.getBoundingClientRect().y;
    if (y > 0 || y < -400) {
      return;
    }

    target.style.transform = `translateY(calc(${Math.abs(y)}px * -${scale}))`;
  };

  if (parallaxImage || parallaxContent) {
    if ("IntersectionObserver" in window) {
      let observerOptions = {
        root: null,
        rootMargin: "0px",
      };

      let intersectionCallback = (entries: IntersectionObserverEntry[]) => {
        if (entries[0].isIntersecting) {
          if (parallaxImage) {
            window.addEventListener("scroll", () => {
              shift(featuredImage, featuredImageShiftScale);
            });
          }
        }
      };
      let observer = new window.IntersectionObserver(
        intersectionCallback,
        observerOptions
      );
      observer.observe(el);
    }
  }

  if (checkInViewport) {
    inViewport(
      el,
      {
        offset: -el.offsetHeight,
      },
      () => {
        set(el, "is-active");
      }
    );
  }
};
